export default __webpack_public_path__ + "static/media/logofeher.4fcacfd4.png";